/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_newsletter_footer_subscribe_title = /** @type {(inputs: {}) => string} */ () => {
	return `Přihlaste se k odběru našeho zpravodaje`
};

const da_newsletter_footer_subscribe_title = /** @type {(inputs: {}) => string} */ () => {
	return `Tilmeld dig vores nyhedsbrev`
};

const de_newsletter_footer_subscribe_title = /** @type {(inputs: {}) => string} */ () => {
	return `Abonnieren Sie unseren Newsletter`
};

const en_newsletter_footer_subscribe_title = /** @type {(inputs: {}) => string} */ () => {
	return `Subscribe to our newsletter`
};

const es_newsletter_footer_subscribe_title = /** @type {(inputs: {}) => string} */ () => {
	return `Suscríbete a nuestro boletín`
};

const fr_newsletter_footer_subscribe_title = /** @type {(inputs: {}) => string} */ () => {
	return `Abonnez-vous à notre newsletter`
};

const hu_newsletter_footer_subscribe_title = /** @type {(inputs: {}) => string} */ () => {
	return `Iratkozzon fel hírlevelünkre`
};

const it_newsletter_footer_subscribe_title = /** @type {(inputs: {}) => string} */ () => {
	return `Iscriviti alla nostra newsletter`
};

const nl_newsletter_footer_subscribe_title = /** @type {(inputs: {}) => string} */ () => {
	return `Abonneer je op onze nieuwsbrief`
};

const pl_newsletter_footer_subscribe_title = /** @type {(inputs: {}) => string} */ () => {
	return `Zapisz się do naszego newslettera`
};

const pt_newsletter_footer_subscribe_title = /** @type {(inputs: {}) => string} */ () => {
	return `Inscreva-se na nossa newsletter`
};

const sv_newsletter_footer_subscribe_title = /** @type {(inputs: {}) => string} */ () => {
	return `Prenumerera på vårt nyhetsbrev`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const newsletter_footer_subscribe_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.newsletter_footer_subscribe_title(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("newsletter_footer_subscribe_title", locale)
	if (locale === "cs") return cs_newsletter_footer_subscribe_title(inputs)
	if (locale === "da") return da_newsletter_footer_subscribe_title(inputs)
	if (locale === "de") return de_newsletter_footer_subscribe_title(inputs)
	if (locale === "en") return en_newsletter_footer_subscribe_title(inputs)
	if (locale === "es") return es_newsletter_footer_subscribe_title(inputs)
	if (locale === "fr") return fr_newsletter_footer_subscribe_title(inputs)
	if (locale === "hu") return hu_newsletter_footer_subscribe_title(inputs)
	if (locale === "it") return it_newsletter_footer_subscribe_title(inputs)
	if (locale === "nl") return nl_newsletter_footer_subscribe_title(inputs)
	if (locale === "pl") return pl_newsletter_footer_subscribe_title(inputs)
	if (locale === "pt") return pt_newsletter_footer_subscribe_title(inputs)
	return sv_newsletter_footer_subscribe_title(inputs)
};
export { newsletter_footer_subscribe_title as "newsletter.footer.subscribe_title" }